export const pathMatch = (path1: string, path2: string): boolean => {
  if (!path1 || !path2) return false
  return path1?.split('?')?.[0] === path2?.split('?')?.[0]
}
